import React from "react";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  zIndex: 2000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};

const boxStyle = {
  backgroundColor: "white",
  padding: "30px",
  borderRadius: "10px",
  maxHeight: "80vh",
  overflowY: "auto",
  width: "600px",
  maxWidth: "90%"
};

const PushSummaryOverlay = ({ summary, onClose }) => {
  return (
    <div style={overlayStyle}>
      <div style={boxStyle}>
        <h4 className="mb-3">Bulk Push Summary</h4>
        <ul className="list-group mb-3">
          {summary.map(({ id, message }, index) => (
            <li key={index} className="list-group-item">
              <strong>ID:</strong> {id} <br />
              <strong>Message:</strong> {message}
            </li>
          ))}
        </ul>
        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default PushSummaryOverlay;
